import ModalContent from 'components/hoc/PopupModal/ModalContent';
import { ComponentType } from 'components/hoc/PopupModal/ModalEnum';
import ModalFooter from 'components/hoc/PopupModal/ModalFooter';
import React from 'react';
import './InspectorSearch.css';

export interface IProps {
  hideSearchButton?: boolean;
  filterHeader: string;
  onSearchFilterClose: any;
  onSearchClicked: any;
  showSearchFilter: boolean;
  isFormDisabled?: boolean;
  searchBtnText?: string;
  children: React.ReactNode;
}

export const InspectorSearch: React.FC<IProps> = (props) => {
  const handleSubmit = (event: any) => {
    event.preventDefault();
    if (props.onSearchClicked) {
      props.onSearchClicked();
    }
  };

  return (
    <div className={'inspector-search'} data-testid="div1-inspector-search">
      <div>
        <ModalContent isLoading={false}>
          <div>
            {props.isFormDisabled ? (
              <React.Fragment>
                {props.children}
                <input
                  data-testid="submit-input"
                  type="submit"
                  style={{ display: 'none' }}
                  onSubmit={handleSubmit}
                  value="Submit"
                />
              </React.Fragment>
            ) : (
              <form onSubmit={handleSubmit} data-testid="form-submit">
                {props.children}
                <input
                  data-testid="submit-input"
                  type="submit"
                  style={{ display: 'none' }}
                  onSubmit={handleSubmit}
                  value="Submit"
                />
              </form>
            )}
          </div>
        </ModalContent>
      </div>
      <div>
        <ModalFooter
          hideSearchButton={props.hideSearchButton}
          componentType={ComponentType.Search}
          isComponentLoading={false}
          onCancelClicked={props.onSearchFilterClose}
          onOperatioConfirmed={props.onSearchClicked}
          btnText={props.searchBtnText}
        />
      </div>
    </div>
  );
};
